import {Component, Input, Optional} from '@angular/core';
import {User} from '../../../../types';
import {TwoFaService, MfaInitiateResponse} from '../../services/2fa.service';
import {Translatable, TranslationService} from '@ngmedax/translation';
import {TRANSLATION_2FA_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';

// hack to inject decorator declarations. must occur before class declaration!
export interface UserMfaComponent extends Translatable {}

@Component({
  selector: 'app-user-mfa',
  templateUrl: './user-mfa.component.html',
  styleUrls: ['../user-card.css', './user-mfa.component.css']
})
@Translatable({scope: TRANSLATION_2FA_SCOPE, keys: KEYS})
export class UserMfaComponent {
  @Input() user: User;

  public mfaSetup: MfaInitiateResponse = null;
  public mfaCode: string = '';
  public mfaDisableCode: string = '';

  public constructor(
    private twoFaService: TwoFaService,
    @Optional() private translationService: TranslationService
  ) {
  }

  /** Secret key in groups of four characters, easier to type into an app */
  public get secretGroups(): string {
    return ((this.mfaSetup && this.mfaSetup.secretBase32) || '').replace(/(.{4})/g, '$1 ').trim();
  }

  /** Leaves the setup without enabling 2FA */
  public cancelSetup() {
    this.mfaSetup = null;
    this.mfaCode = '';
  }

  public initiateMfa() {
    if (!this.user || !this.user.userId || this.user.mfaEnabled) { return; }
    const username = this.user.email;
    this.twoFaService.initiateSetup(this.user.userId, {username, issuer: 'myMedax'})
      .then(resp => this.mfaSetup = resp)
      .catch(() => alert(this._(KEYS.TWO_FA.ERROR_SETUP_START)));
  }

  public verifyMfa() {
    if (!this.user || !this.user.userId || !this.mfaCode) { return; }
    this.twoFaService.verifySetup(this.user.userId, this.mfaCode)
      .then(success => {
        if (success) {
          alert(this._(KEYS.TWO_FA.ENABLED_SUCCESS));
          this.mfaSetup = null;
          this.mfaCode = '';
          if (this.user) { this.user.mfaEnabled = true; }
        } else {
          alert(this._(KEYS.TWO_FA.INVALID_CODE));
        }
      })
      .catch(() => alert(this._(KEYS.TWO_FA.ERROR_VERIFY)));
  }

  public disableMfaSelf() {
    if (!this.user || !this.user.userId) { return; }
    this.twoFaService.disable(this.user.userId, this.mfaDisableCode)
      .then(success => {
        if (success) {
          alert(this._(KEYS.TWO_FA.DISABLED_SUCCESS));
          this.mfaDisableCode = '';
          this.mfaSetup = null;
          if (this.user) { this.user.mfaEnabled = false; }
        } else {
          alert(this._(KEYS.TWO_FA.ERROR_DISABLE));
        }
      })
      .catch(() => alert(this._(KEYS.TWO_FA.ERROR_DISABLE)));
  }
}


